import ListHeader from '../OrderListPage/ListHeader/index.js'
import OrderList from './OrderList.js'
import ActionPanel from './ActionPanel/index.js'
import NewOrdersAlert from './NewOrdersAlert.js'
import OrderListOmniBar from './OrderListOmniBar.js'
import {onlyIfForm, useSelector} from '../../store.js'
import {hasOrderPermissionSelector} from '../../data/me.js'
import NoPermissionsPage from '../NoPermissionsPage.js'
import OrderRevisionAlert from './OrderRevisionAlert.js'
import {orderListFormSelector} from './orderListSelectors.js'
import Modals from './Modals/index.js'
import {HotKeyConnect} from '../../common/components/HotKeys.js'
import {HK_START_PICK_SCAN} from '../../common/constants/HotKeys.js'
import {showPickOrdersModal} from '../PackShipPage/Modals/PickOrdersModal.js'

function OrderListPage() {
  const hasOrderPermission = useSelector(hasOrderPermissionSelector)

  if (!hasOrderPermission) {
    return <NoPermissionsPage />
  }

  return (
    <div id="iverson-page">
      <Modals />
      <HotKeyConnect
        code={HK_START_PICK_SCAN}
        func={() => showPickOrdersModal()}
      />
      <div className="wrap--container">
        <div className="wrap--row">
          <div className="medium-12 columns">
            <NewOrdersAlert />
          </div>
        </div>
        <div className="wrap--row">
          <div className="medium-12 columns">
            <ListHeader />
          </div>
        </div>
        <div className="wrap--row margin-bottom-15">
          <div className="medium-12 columns flex">
            <OrderListOmniBar />
            <OrderRevisionAlert />
          </div>
        </div>
        <div className="wrap--row">
          <OrderList />
          <div className="medium-4 columns">
            <ActionPanel />
          </div>
        </div>
      </div>
    </div>
  )
}

export default onlyIfForm(OrderListPage, orderListFormSelector)
